import { Component, OnInit, ViewChild } from '@angular/core';
import { KontableComponent } from "../../../modules/UIKit/components/kontable/kontable.component";
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LoyaltyCatalogCategoryService } from 'app/services/loyalty/loyalty-catalog-category.service';
import { LoyaltyCatalogCategoryGift } from 'app/models/loyalty-catalog-category-gift';
import { DataTableService } from 'app/modules/UIKit/components/dataTable/dataTable.service';

@Component({
  selector: 'app-loyalty-catalog-category',
  templateUrl: './loyalty-catalog-category.component.html',
  styleUrls: ['./loyalty-catalog-category.component.css']
})
export class LoyaltyCatalogCategoryComponent implements OnInit {
  
  paginationType = KontableComponent.ServerPagination;

  @ViewChild('table') table: any;

  translations: any;
  service: any;
  customerImport: any;

  public categoryGift: LoyaltyCatalogCategoryGift[];
  modalTitle = '';
  labels = {};
  showCategoryDialog = false;

  constructor(
    public categoryGiftService: LoyaltyCatalogCategoryService,
    public srvDataTable: DataTableService,
    private router: Router,
    private message: MessageService

  ) {
    this.service = categoryGiftService;
   }

  ngOnInit() {
  }

  addCategory() {
    this.router.navigate(['loyalty/catalog/category']);
    this.table.refresh();
  }

  deleteCategory(id) {
    this.categoryGiftService.delete(id).subscribe(
      ()=> {
        this.message.add({severity: 'success', summary: 'Success', detail: 'Record Deleted'})
        this.table.refresh();
      }
    )
  }

  showDialog(data) {
    this.categoryGiftService.categoryGiftEdit = !data ? new LoyaltyCatalogCategoryGift() : data;
    this.showCategoryDialog = true;
  }

  closeDialog(){
    this.categoryGiftService.categoryGiftEdit = null;
    this.addCategory();
    this.showCategoryDialog = false;
  }

  applicationAdded(event): void {
    this.categoryGiftService.post(event).subscribe(() => {
      this.message.add({ severity: 'success', summary: 'Success', detail: 'Category Saved' });
      this.closeDialog();
    });
  }

  applicationUpdated(event): void {
    this.categoryGiftService.put(event, event.id).subscribe(() => {
        this.message.add({ severity: 'success', summary: 'Success', detail: 'Category Updated' });
        this.closeDialog();
      });
  }


}


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-category/loyalty-catalog-category.component.ts